import { createContext } from "react";

import {CategoryInterface} from "../../interfaces/Category";

interface InfoInterface {
  logo: string,
  title: string,
  description: string,
}

interface WebInfoInterface {
  webInfo: InfoInterface;
  categorys: CategoryInterface[],
  // options: any[],
  searchQuery: String,
  setSearchQuery: (search: string) => void,
}

const WebInfoContext = createContext<WebInfoInterface>({
  webInfo: {logo: "",title: "",description: ""},
  categorys: [],
  // options: [],
  
  searchQuery: "",
  setSearchQuery: () => {},
});

export default WebInfoContext;
